'use strict';

/*eslint-disable*/

var gSTB = window.gSTB,
    audioManager, stbAudioOutput, playerManager,
    stbPlayer = {},
    volumeValue = gSTB.GetVolume() || 0,
    muteValue = !!gSTB.GetMute(),
    volumeWrapper = {};

if ( window.stbAudioManager ) {
    audioManager = window.stbAudioManager;
} else {
    stbAudioOutput = {};

    Object.defineProperties(stbAudioOutput, {
        /**
         * Master mute state of audio output.
         *
         * After the cycle of switching off/on with this property the volume level remains unchanged.
         *
         * @type {boolean}
         */
        mute: {
            get: function () {
                return !!gSTB.GetMute();
            },
            set: function ( value ) {
                gSTB.SetMute(!!value);
            }
        },

        /**
         * Master volume level in percents (0 - no sound, 100 - maximal level).
         *
         * @type {number}
         */
        volume: {
            get: function () {
                return gSTB.GetVolume();
            },
            set: function ( value ) {
                gSTB.SetVolume(+value);
            }
        }
    });

    audioManager = {
        /**
         * Get array of all available stbAudioOutput instances in the system.
         *
         * @type {stbAudioOutput[]}
         * @readonly
         *
         * @example
         * // get audio output #1 instance
         * var output = stbAudioManager.list[1];
         * // and link it with a player
         * output.source = stbPlayerManager.list[1];
         */
        list: [stbAudioOutput]
    };
}

if ( window.stbPlayerManager ) {
// if ( false ) {
    playerManager = window.stbPlayerManager;
} else {
    Object.defineProperties(stbPlayer, {
        /**
         * Mute state of audio output.
         *
         * This is a combination of master mute state (see {@link stbAudioOutput.mute}) and local player state.
         *
         * After the cycle of switching off/on with this property the volume level remains unchanged.
         *
         * @type {boolean}
         */
        mute: {
            get: function () {
                return gSTB.GetMute();
            },
            set: function ( val ) {
                gSTB.SetMute(val? 1 : 0);
            }
        },


        /**
         * Current volume level in percents (0 - no sound, 100 - maximal level).
         *
         * This is a combination of master volume level (see {@link stbAudioOutput.volume}) and local player volume level.
         *
         * @type {number}
         */
        volume: {
            get: function () {
                return gSTB.GetVolume();
            },
            set: function ( val ) {
                gSTB.SetVolume(+val);
            }
        }
    });


    playerManager = {
        list: [stbPlayer]
    }
}


volumeWrapper.init = function ( volume, mute ) {
    var idx;

    volumeValue = volume;
    muteValue = !!mute;

    for ( idx = 0; idx < audioManager.list.length; idx++ ) {
        audioManager.list[idx].volume = 100;
        audioManager.list[idx].mute = false;
    }

    for ( idx = 0; idx < playerManager.list.length; idx++ ) {
        playerManager.list[idx].volume = volume;
        playerManager.list[idx].mute = mute;
    }
};

Object.defineProperties(volumeWrapper, {
    volume: {
        get: function () {
            return volumeValue;
        },
        set: function ( value ) {
            var idx;

            volumeValue = value;

            for ( idx = 0; idx < playerManager.list.length; idx++ ) {
                playerManager.list[idx].volume = value;
            }
        }
    },
    mute: {
        get: function () {
            return muteValue;
        },
        set: function ( value ) {
            var idx;

            muteValue = !!value;

            for ( idx = 0; idx < playerManager.list.length; idx++ ) {
                playerManager.list[idx].mute = value;
            }
        }
    }
});


module.exports = volumeWrapper;
